import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { useEffect } from "react";
import { $getRoot } from "lexical";

export default function BlockTagPlugin() {
    const [editor] = useLexicalComposerContext();

    useEffect(() => {
        const applyTags = () => {
            editor.getEditorState().read(() => {
                const root = $getRoot();
                const blocks = root.getChildren();

                const rootEl = editor.getRootElement();
                if (!rootEl) return;

                blocks.forEach((block) => {
                    const dom = editor.getElementByKey(block.getKey());
                    if (!dom) return;

                    let tag =
                        typeof block.getTag === "function" ? block.getTag() : block.getType();

                    if (tag === "paragraph") {
                        tag = "p";
                    }

                    dom.setAttribute("data-block-tag", tag);
                    if (!dom.style.position) {
                        dom.style.position = "relative";
                    }
                });
            });
        };

        applyTags();

        return editor.registerUpdateListener(() => {
            applyTags();
        });
    }, [editor]);

    return null;
}
